import { atom } from 'jotai';

import type { ResourceType } from '../types';

export const resourceTypeAtom = atom<ResourceType | null>(null);
export const resourceIdAtom = atom<string | null>(null);
export const currentArchiveIdAtom = atom<string | null>(null);
export const currentFolderIdAtom = atom<string | null>(null);
export const scopeKeyAtom = atom((get) => {
  const type = get(resourceTypeAtom);
  const id = get(resourceIdAtom);
  return type && id ? `${type}:${id}` : '';
});
